import { render, staticRenderFns } from "./left_under_arm.vue?vue&type=template&id=f236608c"
import script from "./left_under_arm.vue?vue&type=script&lang=js"
export * from "./left_under_arm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports